import * as XLSX from "xlsx";

/**
 * Método genérico para exportar datos a Excel con formato y nombre automático.
 *
 * @param sheetName - Nombre de la hoja dentro del archivo Excel.
 * @param data - Datos a exportar (array de objetos).
 * @param formatFileName - Función para generar el nombre del archivo (opcional).
 */
export const generateExcelFile = (
	sheetName: string,
	data: any[],
	formatFileName?: () => string
): void => {
	if (!data || data.length === 0) {
		console.error("No hay datos para exportar a Excel");
		return;
	}

	const fileName =
		formatFileName?.() || `Document_${new Date().toISOString().replace(/:/g, "-")}.xlsx`;

	const workbook = XLSX.utils.book_new();
	const worksheet = XLSX.utils.json_to_sheet(data);

	worksheet["!cols"] = Object.keys(data[0]).map((key) => ({
		wch: key.length + 5,
	}));

	XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

	XLSX.writeFile(workbook, fileName);
};

/**
 * Genera un nombre de archivo personalizado con fecha y hora.
 *
 * @returns Nombre del archivo con formato.
 */
export const generateExcelFileName = (prefix: string = "Document") => {
	const now = new Date();
	const formattedDate = now.toISOString().split("T")[0];
	const formattedTime = now.toTimeString().split(" ")[0].replace(/:/g, "-");
	return `${prefix}_${formattedDate}_${formattedTime}.xlsx`;
};
